<script>
import { mapActions } from 'vuex'
import { useAlert } from 'dashboard/composables';

export default {
  name: 'DeleteConfirmModal',
  props: {
    selectedInbox: { type: Object, required: true },
    deleteTargetId: { type: Number, required: true },
    question: { type: String, required: true }
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    ...mapActions('whitelist', ['deleteWhitelistQuestion']),
    async handleDelete() {
      if (!this.selectedInbox.id) {
        useAlert('Please select an inbox first')
        return
      }
      this.isLoading = true
      try {
        await this.deleteWhitelistQuestion({
          accountId: this.$route.params.accountId,
          inboxId: this.selectedInbox.id,
          questionId: this.deleteTargetId,
        })
        useAlert('Question deleted successfully!')
        this.$emit('refresh')
        this.$emit('close')
      } catch (e) {
        useAlert('Failed to delete question')
      } finally {
        this.isLoading = false
      }
    },
  }
}
</script>

<template>
  <div
    class="fixed inset-0 flex items-center justify-center bg-slate-800/50 z-50"
  >
    <div class="bg-white dark:bg-slate-800 rounded-lg p-6 shadow-lg w-96">
      <h2 class="text-lg font-semibold text-slate-800 dark:text-slate-200 mb-4">
        Confirm Deletion
      </h2>
      <div class="mb-6">
        <p class="text-slate-600 dark:text-slate-300 mb-4">
          Are you sure you want to delete this question? This action cannot be undone.
        </p>
        <div class="p-3 bg-slate-50 dark:bg-slate-700 rounded-md border border-slate-200 dark:border-slate-600">
          <p class="text-slate-700 dark:text-slate-200 font-medium">{{ question }}</p>
        </div>
      </div>

      <div class="flex justify-end gap-3">
        <woot-button
          variant="clear"
          color-scheme="secondary"
          @click="$emit('close')"
          :disabled="isLoading"
        >
          Cancel
        </woot-button>
        <woot-button
          variant="smooth"
          color-scheme="alert"
          @click="handleDelete"
          :disabled="isLoading"
          :loading="isLoading"
        >
          {{ isLoading ? 'Deleting...' : 'Delete' }}
        </woot-button>
      </div>
    </div>
  </div>
</template>
